"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterClearService = void 0;
var tslib_1 = require("tslib");
var FullTextSearchApi_1 = require("src/search/fullText/FullTextSearchApi");
var FilterTypings_1 = require("Views/Partials/Components/Filters/FilterTypings");
var HierarchyService_1 = require("./HierarchyService");
var SearchResultsService_1 = require("./SearchResultsService");
var FilterClearService = /** @class */ (function () {
    function FilterClearService() {
        this.clearFilters = function (filters, selectedFilters, isFilterToClear) {
            var newFilters = tslib_1.__assign({}, filters);
            var newSelectedFilters = tslib_1.__assign({}, selectedFilters);
            var filterGroupsAlias = Object.keys(filters);
            filterGroupsAlias.forEach(function (filterGroup) {
                var filter = filters[filterGroup];
                if (isFilterToClear(filter, filterGroup)) {
                    delete newSelectedFilters[filterGroup];
                }
            });
            return { filters: newFilters, selectedFilters: newSelectedFilters };
        };
        this.isTypeRelatedFilterToClear = function (filter, filterGroup) {
            return filterGroup !== FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias;
        };
        this.isSegmentRelatedFilterToClear = function (filter, filterGroup) {
            return (filterGroup !== FullTextSearchApi_1.FullTextSearchFilters.DocumentationLanguageFilterAlias &&
                filterGroup !== FullTextSearchApi_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias &&
                filterGroup !== FullTextSearchApi_1.FullTextSearchFilters.DrawingsDrawingTypeFilterAlias &&
                filterGroup !== FullTextSearchApi_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias &&
                filterGroup !== FullTextSearchApi_1.FullTextSearchFilters.DocumentationCountryFilterAlias &&
                filterGroup !== FullTextSearchApi_1.FullTextSearchFilters.DocumentationArchivedFilterAlias &&
                filterGroup !== FullTextSearchApi_1.FullTextSearchFilters.DownloadSoftwareTypeFilterAlias &&
                filterGroup !== FullTextSearchApi_1.FullTextSearchFilters.CourseLanguageFilterAlias &&
                filterGroup !== FullTextSearchApi_1.FullTextSearchFilters.CourseDeliveryTypesFilterAlias &&
                filterGroup !== FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias &&
                !SearchResultsService_1.SearchResultsService.isSegmentFilterOfAnyType(filterGroup));
        };
        this.isCountryRelatedFilterToClear = function (filter, filterGroup) {
            return filterGroup === FullTextSearchApi_1.FullTextSearchFilters.CareersLocationFilterAlias;
        };
    }
    FilterClearService.prototype.getMatchFilterToClearFunction = function (targetGroup, filters, _selectedFilters) {
        if (targetGroup === FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias) {
            return this.isTypeRelatedFilterToClear;
        }
        if (SearchResultsService_1.SearchResultsService.isSegmentFilterOfAnyType(targetGroup)) {
            return this.isSegmentRelatedFilterToClear;
        }
        if (filters[targetGroup].guiType === FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy) {
            return this.getHierarchyFilterToClearFunction(targetGroup, filters);
        }
        if (targetGroup === FullTextSearchApi_1.FullTextSearchFilters.DocumentationCountryFilterAlias ||
            targetGroup === FullTextSearchApi_1.FullTextSearchFilters.CareersCountryFilterAlias) {
            return this.isCountryRelatedFilterToClear;
        }
        return null;
    };
    FilterClearService.prototype.getHierarchyFilterToClearFunction = function (targetGroup, filters) {
        var longestLevel = HierarchyService_1.HierarchyService.getHierarchyFilterLevel(filters[targetGroup].items[0].value);
        return function (filter) {
            if (filter.guiType !== FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy)
                return false;
            var filterLevel = HierarchyService_1.HierarchyService.getHierarchyFilterLevel(filter.items[0].value);
            return filterLevel > longestLevel;
        };
    };
    return FilterClearService;
}());
var service = new FilterClearService();
exports.FilterClearService = service;
